import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { PopupInfoAltimaComponent } from "@shared/components/offers/MRH/service-offerings-mrh/popup-info-altima/popup-info-altima.component";
import { ClaimsRedirectValues } from "@shared/enums/claims-redirect-values";
import { ClaimsType } from "@shared/enums/claims.type";
import { ClaimsService } from "@shared/services/claims.service";
import { ButtonModule } from "primeng/button";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { ToastModule } from "primeng/toast";
@Component({
  selector: "app-claims-button-mrh",
  standalone: true,
  imports: [CommonModule, ButtonModule, TranslateModule, ToastModule],
  templateUrl: "./claims-button.component.html",
  providers:[DialogService]
})
export class ClaimsButtonMRHComponent {
  @Input({ required: true }) policyReference!: string;
  @Input() claimsType!: ClaimsType;
  @Input() claimsRedirectValue!: ClaimsRedirectValues;
  @Input() text!: string;
  @Input() logo!: string;
  ClaimsRedirectValues = ClaimsRedirectValues;
  ClaimsType = ClaimsType;
  isLoading = false;


  refPopupAltima: DynamicDialogRef |undefined;

  constructor(
    private readonly claimsService: ClaimsService,
    private readonly dialogService: DialogService,
    private readonly translateService: TranslateService
    ,
  ) {}

  public redirectToClaims(claimsType: string, redirectValue: string): void {
    this.isLoading = true;


    if(claimsType === ClaimsType.ALTIMA) {
      // display a popup
      this.refPopupAltima = this.dialogService.open(PopupInfoAltimaComponent, {
        header: this.translateService.instant('modal.Information'),
        width: '35%',
        draggable: false,
        closable: true
      });

      this.refPopupAltima.onClose.subscribe(() => { 
        this.isLoading = false;
      });
      return;

    }

    if (claimsType === ClaimsType.CED) {
      this.claimsService.redirectCED(this.policyReference, redirectValue).subscribe(() => {
        this.isLoading = false;
      });
    } else if (claimsType === ClaimsType.SFPJ) {
      if (redirectValue === ClaimsRedirectValues.SFPJContracts) {
        this.claimsService.redirectDigidroit().subscribe(() => {
          this.isLoading = false;
        });
      } else {
        this.claimsService.redirectSFPJ(this.policyReference, redirectValue).subscribe(() => {
          this.isLoading = false;
        });
      }
    }
  }
}
